import { Avatar } from "@mui/material";
import React from "react";

export default function SmallClientChipMobile(props) {
  return (
    <div className="small-client-chip-container-mobile">
      <Avatar
        style={{
          width: "30px",
          height: "30px",
        }}
        src={props.clientPic}
      />
      <div className="small-client-chip-name-mobile">
        {props.firstName} {props.lastName}
      </div>
    </div>
  );
}
